import { render, staticRenderFns } from "./selectProduct.vue?vue&type=template&id=041f8212"
import script from "./selectProduct.vue?vue&type=script&lang=js"
export * from "./selectProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('041f8212')) {
      api.createRecord('041f8212', component.options)
    } else {
      api.reload('041f8212', component.options)
    }
    module.hot.accept("./selectProduct.vue?vue&type=template&id=041f8212", function () {
      api.rerender('041f8212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/formOverlay/selectProduct.vue"
export default component.exports